module.exports = __webpack_public_path__ + "img/img_02.44c45efc.png";